export class WishlistDb {
  db: string
  table: string
  cnx: any

  constructor() {
    this.db = 'wishlist'
    this.table = 'items'
  }

  openDb(): any {
    return new Promise((resolve) => {
      if (!process.client) {
        resolve(true)
      } else {
        const request = window.indexedDB.open(this.db, 1)

        request.onsuccess = () => {
          this.cnx = request.result
          resolve(true)
        }

        request.onupgradeneeded = (changeEvent: any) => {
          const objectStore = changeEvent.target.result.createObjectStore(
            this.table,
            {
              keyPath: 'slug',
              autoIncrement: false,
            }
          )

          objectStore.onsuccess = () => {
            this.cnx = changeEvent.target.result
            resolve(true)
          }

          objectStore.createIndex('timestamp', 'timestamp', { unique: false })
        }
      }
    })
  }

  put(entity: object) {
    return new Promise((resolve) => {
      if (!process.client) {
        resolve(true)
      } else {
        this.cnx
          .transaction([this.table], 'readwrite')
          .objectStore(this.table)
          .put(entity).onsuccess = () => {
          resolve(true)
        }
      }
    })
  }

  get(setSlug: string) {
    return new Promise((resolve) => {
      if (setSlug !== '' && process.client) {
        const response = this.cnx
          .transaction([this.table], 'readwrite')
          .objectStore(this.table)
          .get(setSlug)

        response.onsuccess = () => {
          resolve(response.result)
        }
      } else {
        resolve(false)
      }
    })
  }

  delete(setSlug: string) {
    return new Promise((resolve) => {
      if (setSlug !== '' && process.client) {
        this.cnx
          .transaction([this.table], 'readwrite')
          .objectStore(this.table)
          .delete(setSlug).onsuccess = () => {
          resolve(true)
        }
      } else {
        resolve(false)
      }
    })
  }

  clear() {
    return new Promise((resolve) => {
      if (!process.client) {
        resolve(true)
      } else {
        const response = this.cnx
          .transaction([this.table], 'readwrite')
          .objectStore(this.table)
          .clear()

        response.onsuccess = () => {
          resolve(true)
        }
      }
    })
  }

  getAll() {
    return new Promise((resolve) => {
      if (!process.client) {
        resolve([])
      } else {
        const result: any = []

        const objectStore = this.cnx
          .transaction([this.table], 'readwrite')
          .objectStore(this.table)

        objectStore.index('timestamp').openCursor(null, 'prev').onsuccess = (
          event: any
        ) => {
          const cursor = event.target.result
          if (cursor) {
            result.push(cursor.value)
            cursor.continue()
          }
        }

        objectStore.transaction.oncomplete = () => {
          resolve(result)
        }
      }
    })
  }
}
